export enum IndustryName {
  ABA = 'Abattoir/Slaughterhouse',
  ACA = 'Anti-Corruption Agency',
  ACET = 'Acetylene Gas Manufacture',
  ACT = 'Actuary',
  ACU = 'Acupuncturist',
  ADJ = 'Adjuster',
  ADM = 'Administrators',
  ADV = 'Advertising',
  AER = 'Aerial Erection',
  AGE = 'Agent',
  AGR = 'Agriculture and Fisheries Dept',
  AIR = 'Airport',
  AIRA = 'Aircraft Industry',
  AIRC = 'Air Conditioning',
  AMB = 'Ambulance Services',
  AMU = 'Amusement Park',
  ANT = 'Antique',
  API = 'Apiarist/Bee Keeper',
  ARC = 'Architectural',
  ARMA = 'Airforce',
  ARML = 'Navy',
  ARMY = 'Army',
  ART = 'Artist',
  ARTI = 'Artificial Flower Industry',
  ARTL = 'Artificial Leather Industry',
  ASB = 'Asbestos Industry',
  ASS = 'Assayer',
  AST = 'Astrologer',
  ASTR = 'Astronomer',
  ATT = 'Attendant',
  AUC = 'Auctioneer',
  AUT = 'Author/Authoress',
  AUTO = 'Automobile Industry',
  AUX = 'Auxiliary Medical Service',
  AVI = 'Aviation',
  BABY = 'Babysitter/Nanny',
  BACT = 'Bacteriologist',
  BAI = 'Bailiff',
  BAK = 'Bakeries',
  BAKE = 'Bakelite and Plastic Manufacture',
  BANK = 'Bank/Financial Institution',
  BAR = 'Bar/Coffee House',
  BARB = 'Barber',
  BATE = 'Batek Painter and Printer',
  BATH = 'Baths, Beaches and Pools',
  BATT = 'Battery Manufacture',
  BEAU = 'Beauty Parlour',
  BEVE = 'Beverage and Bottling Industry',
  BICY = 'Bicycle Shop',
  BIL = 'Bill Collector',
  BILL = 'Billiards/Snooker/Pool',
  BILP = 'Bill/Poster Sticker',
  BING = 'Bingo Hall',
  BIO = 'Biologist',
  BIRD = 'Birds Nest Collector',
  BLAC = 'Blacksmith',
  BLAS = 'Blaster',
  BLIN = 'Blind Maker',
  BOAT = 'Boat Builder',
  BOIL = 'Boiler Industry',
  BOOK = 'Bookkeeper',
  BOTA = 'Botanist',
  BOUN = 'Bouncer',
  BOWL = 'Bowling Alley',
  BRIC = 'Brick, Pipe and Tile Manufacture',
  BRIK = 'Bricklayer',
  BROK = 'Broker',
  BROM = 'Broom/Brushmaker',
  BUIC = 'Building Construction',
  BUIM = 'Building Maintenance',
  BULT = 'Bulldozer/Tractor Driver',
  BUSC = 'Business Consultant',
  BUSI = 'Business Machines Sales and Services',
  BUST = 'Bus Transportation',
  BUTC = 'Butcher',
  BUTL = 'Butler',
  CAN = 'Candle Maker',
  CANT = 'Canteen',
  CAPP = 'Canning Factory',
  CARE = 'Caretaker',
  CARG = 'Carpet and Rug',
  CARP = 'Carpenter',
  CART = 'Cartographer',
  CASH = 'Cashier',
  CASI = 'Casino',
  CATE = 'Catering Industry',
  CEGL = 'Cement, Gypsum and Lime Industry',
  CHAR = 'Charcoal Manufacture',
  CHAW = 'Charworker',
  CHEF = 'Chef/Cook',
  CHEM = 'Chemist',
  CHIM = 'Child Minder',
  CHIR = 'Chiropractor',
  CINE = 'Cinema',
  CIRC = 'Circus',
  CIVI = 'Civil Aid Services',
  CLEA = 'Cleaner',
  CLOC = 'Clock Shop',
  CLOT = 'Cloth Manufacturer',
  CLUB = 'Club',
  COBB = 'Cobbler/Shoemaker',
  COFF = 'Coffee Shop',
  COLD = 'Cold Storage',
  COMD = 'Company Director',
  COMM = 'Commercial Crime Office',
  COMP = 'Computer Industry',
  CONR = 'Contractor',
  CONT = 'Container Industry',
  COOK = 'Cook',
  COPY = 'Legal Profession',
  COR = 'Coroner',
  CORR = 'Correctional Services Department',
  CRAN = 'Crane Driver/Operator',
  CUSE = 'Customs and Excise Department',
  DAIR = 'Dairy Product Processing',
  DANC = 'Dancing',
  DATA = 'Data Processing',
  DEBT = 'Debt Collector',
  DECO = 'Decorator, Interior',
  DELE = 'Delivery, Express and Moving Companies',
  DELI = 'Deliveryman, Driver',
  DEMO = 'Demolition Trade',
  DEMS = 'Demonstrator (Products)',
  DENT = 'Dentistry',
  DEPA = 'Department Stores',
  DESI = 'Designer',
  DET = 'Detective',
  DIAM = 'Diamonds and Gemstones',
  DIPL = 'Diplomatic Service',
  DISC = 'Disco',
  DIST = 'Distillery',
  DIVE = 'Diver',
  DOC = 'Doctor',
  DOCK = 'Dock',
  DOOR = 'Doorman',
  DRES = 'Dressmaker, Seamstress and Tailor',
  DRIV = 'Driver',
  DRY = 'Dry Cleaning',
  DRYB = 'Dry Batteries Manufacture',
  DUST = 'Dustman/Refuse Collector',
  ECO = 'Ecologist',
  ECON = 'Economist',
  EDIT = 'Editor',
  ELEC = 'Electricity Supply Industry',
  ELEI = 'Electronic Industry',
  ELEP = 'Electroplater (Light Industries)',
  ELEV = 'Elevator',
  ENGI = 'Engineer (Non Hazardous Industry)',
  ENGR = 'Engraver',
  ENT = 'Entertainment',
  EXPL = 'Explosives and Firework Manufacture',
  EXT = 'Exterminator',
  FACT = 'Factory Worker',
  FARM = 'Farm',
  FASH = 'Fashion',
  FILM = 'Film Industry',
  FINA = 'Finance/Bank',
  FIRE = 'Fire Department (No RCC)',
  FISH = 'Fishing Industry',
  FISM = 'Fishmonger',
  FITT = 'Fitter',
  FLOR = 'Florist',
  FLOW = 'Flower Grower',
  FORO = 'Forensic Occupations',
  FORR = 'Forestry',
  FORT = 'Fortune Teller',
  FUMI = 'Fumigator',
  FUNE = 'Funeral Industry',
  FURN = 'Furnaceman',
  FURW = 'Furniture/Woodworking Factory',
  GALV = 'Galvanizer and Tinner',
  GAMB = 'Gambler',
  GAMP = 'Game/Park Keeper',
  GARA = 'Garage/Auto-Workshop',
  GARD = 'Gardener',
  GASD = 'Gas Distributor (Cooking)',
  GEO = 'Geologist',
  GLAF = 'Glass Fibre',
  GLAS = 'Glass Industry',
  GOLD = 'Goldsmith',
  GOLF = 'Golf Course/Driving Range',
  GRAI = 'Grain-Milling',
  GRIN = 'Grinder/Buffer',
  GYM = 'Gymnast',
  HAIR = 'Hairdresser',
  HARB = 'Harbourmaster',
  HAWK = 'Hawker',
  HEAC = 'Health/Fitness Club',
  HEAL = 'Health',
  HERB = 'Herbalist',
  HIGH = 'Highway and Road Construction',
  HIRE = 'Hire Operator',
  HOIS = 'Hoist Operator',
  HORS = 'Horse Racing',
  HORT = 'Horticulture',
  HOTE = 'Hotel',
  HOUD = 'Housing Developer',
  HOUK = 'Housekeeper',
  HOUS = 'Housewife/Homemaker',
  ICEI = 'Ice Industry',
  ICES = 'Ice-Cream Seller',
  IMMI = 'Immigration Department',
  INSE = 'Insecticide Manufacturer',
  INSU = 'Insurance',
  INTD = 'Interior Decorator',
  INTP = 'Interpreter',
  JAGA = 'Jaga',
  JANI = 'Janitor',
  JEWE = 'Jewellery Trade',
  JOUR = 'Journalism',
  JUV = 'Juvenile',
  KENN = 'Kennel',
  KNIT = 'Knitting',
  LABO = 'Laboratory',
  LAUN = 'Laundry',
  LEAT = 'Leather Industry',
  LIBR = 'Library',
  LIFE = 'Life Guard',
  LIFT = 'Lift',
  LIGH = 'Lighthouse Keeper',
  LOCK = 'Locksmith',
  LUMB = 'Lumber Industry',
  MACH = 'Machine Shop (Non Hazardous Industry)',
  MAID = 'Maid',
  MAR = 'Marine',
  MARB = 'Marble Polisher',
  MASO = 'Mason',
  MASS = 'Masseur',
  MATC = 'Match Factory',
  MATT = 'Mattress and Pillow Factory',
  MED = 'Medical Profession',
  MEDI = 'Medical Shop',
  MESS = 'Messenger',
  MET = 'Metallurgist',
  META = 'Metal Industry',
  METE = 'Meteorologist',
  MIDW = 'Midwife',
  MINI = 'Mining Industry',
  MONE = 'Money Lender',
  MUSE = 'Museum',
  MUSI = 'Music Industry',
  NEON = 'Neon Light Signs',
  NEWS = 'Newspaper',
  NICB = 'Night Club',
  NIGW = 'Night Watchman',
  NOOD = 'Noodle Maker',
  NURS = 'Nursing',
  OILN = 'Oil and Gas - Offshore',
  OILO = 'Oil and Gas - Onshore - Exploration and Extraction',
  OILR = 'Oil Refining',
  OPHT = 'Ophthalmic Practitioners',
  OPTI = 'Optical Goods Industry',
  OTH = 'Others',
  OVER = 'Overseas Aid Worker',
  PAIN = 'Painter',
  PAIT = 'Paint, Lacquer and Varnish Industry',
  PAPB = 'Paper/Board Manufacture',
  PAPE = 'Paper and Pulp Industry',
  PARK = 'Park Ranger',
  PART = 'Party Planning',
  PASA = 'Pasar Malam',
  PAWN = 'Pawnbroker',
  PEST = 'Pest Control',
  PHOC = 'Photocopying Machine',
  PHOT = 'Photo Studio',
  PLUM = 'Plumber',
  POL = 'Police',
  POLT = 'Politics',
  PORT = 'Porter',
  POST = 'Post Office',
  POTT = 'Potteries',
  PRIN = 'Printing and Publishing',
  PRIS = 'Prison Service',
  PRIT = 'Private Investigator',
  PRIV = 'Private Company (Class 1)',
  PUBG = 'Public/Government Servant',
  PUBL = 'Public Sanitation',
  PUBR = 'Public Relations',
  QUAR = 'Quarrying',
  RADI = 'Radio and Television Industry',
  RAIL = 'Railways',
  RECE = 'Receptionist',
  REGI = 'Registrar',
  RELI = 'Religion',
  RENT = 'Rent Collector',
  RESR = 'Restorer',
  REST = 'Restaurant',
  RETI = 'Retiree',
  ROAD = 'Road Construction',
  RUBB = 'Rubber Industry',
  RUBS = 'Rubber-Stamp Maker',
  RUGC = 'Rug and Carpet (Clearing and Repairing)',
  SALE = 'Salesperson',
  SAND = 'Sandblaster',
  SCRA = 'Scrap Metal Dealer',
  SCUL = 'Sculptor',
  SECR = 'Secretarial Occupations',
  SECU = 'Security',
  SERV = 'Servant - Domestic Help',
  SHIP = 'Ship Building Industry',
  SING = 'Singer',
  SOAP = 'Soap and Detergent Manufacturer',
  SOCI = 'Social Worker',
  SPOR = 'Sports',
  STEE = 'Steeplejack',
  STOC = 'Stockbroker',
  STON = 'Stone Industry',
  STOR = 'Storekeeper',
  STUD = 'Student',
  STUN = 'Stuntman/Stuntwoman',
  SUGA = 'Sugar Refineries',
  SUPM = 'Supermarket',
  SURV = 'Surveyor',
  TAIL = 'Tailor',
  TALC = 'Talc Industry',
  TAXI = 'Taxidermist',
  TEAC = 'Teacher/Lecturer',
  TEAL = 'Tea Lady',
  TECA = 'Technical Assistant',
  TELE = 'Telecommunications',
  TEXT = 'Textile Industry',
  THEA = 'Theatre',
  TIMB = 'Timber Industry',
  TINS = 'Tinsmith',
  TOBA = 'Tobacco Industry',
  TOOL = 'Toolmaking',
  TOWN = 'Town Planner',
  TOYG = 'Toy Goods Manufacture',
  TRAC = 'Tractor Driver',
  TRAD = 'Trading',
  TRAN = 'Transport (Public)',
  TRAV = 'Travel Agency',
  TUNN = 'Tunnel and Shaft Construction',
  TYPI = 'Typist',
  TYRE = 'Tyre Manufacturer',
  UMBR = 'Umbrella Manufacture',
  UNEM = 'Unemployed',
  UNDE = 'Underwriter',
  UPHO = 'Upholstery',
  VALE = 'Valet',
  VALU = 'Valuer',
  VEND = 'Vending Machines',
  VENE = 'Veneer Binder',
  VENT = 'Ventriloquist',
  VERG = 'Verger',
  VETE = 'Veterinary Practice',
  VOCA = 'Vocational Instructor',
  WARD = 'Warden',
  WARE = 'Warehouse Workers',
  WATE = 'Water Supply Industry',
  WELD = 'Welding/Welder',
  WELF = 'Welfare/Social Work',
  WIDD = 'Window Dresser',
  WIND = 'Window Cleaner',
  WOOD = 'Wood - Associated Trades',
  WRES = 'Wrestler',
  WRIT = 'Writing',
  XRAY = 'X-Ray',
  YOU = 'Youth Leader',
  ZOO = 'Zoo',
  Unknown = 'Uncategorized',
  UNL = 'Not in the list',
}
